// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Waru","bigColWidth":"Table_bigColWidth__3u5i6","biggerColWidth":"Table_biggerColWidth__1PvV7","row":"Table_row__3w0xN","col":"Table_col__3tfsQ"};